import { createRouter, createWebHistory } from 'vue-router'
import { hasApiToken } from './services/api'

const PortalLayout = () => import('./layouts/PortalLayout.vue')
const LoginView = () => import('./views/LoginView.vue')
const DashboardView = () => import('./views/DashboardView.vue')
const OrdersView = () => import('./views/OrdersView.vue')
const HistoryView = () => import('./views/HistoryView.vue')
const MenuView = () => import('./views/MenuView.vue')
const RatingsView = () => import('./views/RatingsView.vue')
const BulkMenuView = () => import('./views/BulkMenuView.vue')
const BranchSettingsView = () => import('./views/BranchSettingsView.vue')
const AccountView = () => import('./views/AccountView.vue')
const FinanceView = () => import('./views/FinanceView.vue')
const OffersView = () => import('./views/OffersView.vue')
const RestaurantProfileView = () => import('./views/RestaurantProfileView.vue')
const TeamAutomationView = () => import('./views/TeamAutomationView.vue')
const CommunicationView = () => import('./views/CommunicationView.vue')
const OnboardingView = () => import('./views/OnboardingView.vue')
const TermsView = () => import('./views/TermsView.vue')

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { guest: true } },
    {
      path: '/',
      component: PortalLayout,
      meta: { auth: true },
      children: [
        { path: '', redirect: '/dashboard' },
        { path: 'dashboard', name: 'dashboard', component: DashboardView },
        { path: 'orders', name: 'orders', component: OrdersView },
        { path: 'history', name: 'history', component: HistoryView },
        { path: 'menu', name: 'menu', component: MenuView },
        { path: 'ratings', name: 'ratings', component: RatingsView },
        { path: 'menu/bulk', name: 'bulk-menu', component: BulkMenuView },
        { path: 'branch-settings', name: 'branch-settings', component: BranchSettingsView },
        { path: 'finance', name: 'finance', component: FinanceView },
        { path: 'offers', name: 'offers', component: OffersView },
        { path: 'restaurant-profile', name: 'restaurant-profile', component: RestaurantProfileView },
        { path: 'team', name: 'team', component: TeamAutomationView },
        { path: 'communication', name: 'communication', component: CommunicationView },
        { path: 'onboarding', name: 'onboarding', component: OnboardingView, meta: { allowWithoutRestaurant: true } },
        { path: 'terms', name: 'terms', component: TermsView, meta: { allowWithoutRestaurant: true } },
        { path: 'account', name: 'account', component: AccountView },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/dashboard' },
  ],
})

router.beforeEach((to) => {
  if (to.meta.auth && !hasApiToken()) return { name: 'login', query: { redirect: to.fullPath } }
  if (to.meta.guest && hasApiToken()) return { name: 'dashboard' }
  return true
})

export default router
